var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIssuers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.821,
    height: 11.112,
    viewBox: "0 0 16.821 11.112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Issuers",
    transform: "translate(-1944.084 -766.562)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1217",
    "data-name": "Path 1217",
    d: "M1953.743,771.966a2.7,2.7,0,1,0-2.7-2.7A2.705,2.705,0,0,0,1953.743,771.966Zm-1.578-2.7a1.579,1.579,0,1,1,1.578,1.579A1.58,1.58,0,0,1,1952.164,769.264Z",
    transform: "translate(-1.249)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1218",
    "data-name": "Path 1218",
    d: "M1959.986,774.018a1.989,1.989,0,1,0-1.989-1.989A1.991,1.991,0,0,0,1959.986,774.018Zm0-2.855a.866.866,0,1,1-.866.866A.866.866,0,0,1,1959.986,771.163Z",
    transform: "translate(-2.497 -0.624)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1219",
    "data-name": "Path 1219",
    d: "M1947.874,774.018a1.989,1.989,0,1,0-1.989-1.989A1.99,1.99,0,0,0,1947.874,774.018Zm-.865-1.989a.865.865,0,1,1,.865.866A.866.866,0,0,1,1947.009,772.029Z",
    transform: "translate(-0.323 -0.624)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1220",
    "data-name": "Path 1220",
    d: "M1957.489,774.946a3.446,3.446,0,0,0-1.32.264,4.839,4.839,0,0,0-7.35,0,3.417,3.417,0,0,0-4.735,3.152.562.562,0,0,0,1.123,0,2.293,2.293,0,0,1,2.969-2.191,4.834,4.834,0,0,0-.524,2.191.562.562,0,0,0,1.124,0,3.719,3.719,0,1,1,7.437,0,.562.562,0,0,0,1.124,0,4.838,4.838,0,0,0-.524-2.191,2.293,2.293,0,0,1,2.969,2.191.562.562,0,0,0,1.123,0A3.419,3.419,0,0,0,1957.489,774.946Z",
    transform: "translate(0 -1.249)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIssuers);
export default __webpack_public_path__ + "static/media/Issuers.1e0020b0.svg";
export { ForwardRef as ReactComponent };